// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getTipos as listTiposAPI,
    getTipo as getTipoAPI,
    addTipo as addTipoAPI,
    updateTipo as updateTipoAPI,
    deleteTipo as deleteTipoAPI,
} from '../../helpers/';

import { tiposApiResponseError, tiposApiResponseSuccess } from './actions';
import { TiposActionTypes } from './constants';

/**
 * List tipos
 */
function* listTipos() {
    try {
        const response = yield call(listTiposAPI);
        const listaTipos = response.data.data;
        yield put(tiposApiResponseSuccess(TiposActionTypes.LIST_TIPOS, listaTipos));
    } catch (error) {
        yield put(tiposApiResponseError(TiposActionTypes.LIST_TIPOS, error));
    }
}

function* getTipo({ payload: { id } }) {
    try {
        const response = yield call(getTipoAPI, id);
        const tipoItem = response.data.data;
        yield put(tiposApiResponseSuccess(TiposActionTypes.GET_TIPO, tipoItem));
    } catch (error) {
        yield put(tiposApiResponseError(TiposActionTypes.GET_TIPO, error));
    }
}

function* addTipo({ payload: tipo }) {
    try {
        const response = yield call(addTipoAPI, { ...tipo })
        const tipoItem = response.data
        yield put(tiposApiResponseSuccess(TiposActionTypes.ADD_TIPO, tipoItem))
    } catch (error) {
        yield put(tiposApiResponseError(TiposActionTypes.ADD_TIPO, error))
    }
}

function* updateTipo({ payload: tipo }) {
    try {
        const response = yield call(updateTipoAPI, { ...tipo })
        const tipoItem = response.data.data
        yield put(tiposApiResponseSuccess(TiposActionTypes.UPDATE_TIPO, tipoItem))
    } catch (error) {
        yield put(tiposApiResponseError(TiposActionTypes.UPDATE_TIPO, error))
    }
}
function* deleteTipo({ payload: { id } }) {
    try {
        const response = yield call(deleteTipoAPI, id)
        const tipoItem = response.data.id
        yield put(tiposApiResponseSuccess(TiposActionTypes.DELETE_TIPO, tipoItem))
    } catch (error) {
        yield put(tiposApiResponseError(TiposActionTypes.DELETE_TIPO, error))
    }
}

export function* watchListTipos(): any {
    yield takeEvery(TiposActionTypes.LIST_TIPOS, listTipos);
}

export function* watchGetTipo(): any {
    yield takeEvery(TiposActionTypes.GET_TIPO, getTipo);
}

export function* watchAddTipo(): any {
    yield takeEvery(TiposActionTypes.ADD_TIPO, addTipo)
}
export function* watchUpdateTipo(): any {
    yield takeEvery(TiposActionTypes.UPDATE_TIPO, updateTipo)
}
export function* watchDeleteTipo(): any {
    yield takeEvery(TiposActionTypes.DELETE_TIPO, deleteTipo)
}


function* tiposSaga(): any {
    yield all([
        fork(watchListTipos),
        fork(watchGetTipo),
        fork(watchAddTipo),
        fork(watchUpdateTipo),
        fork(watchDeleteTipo),
    ]);
}

export default tiposSaga;
